const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  902: {
    path: "/flowManage",
    name: "flowManage",
    meta: {
      title: "流量管理",
      authId: "902",
      parentId: "1",
      cache: false
    }
  },
  90201: {
    path: "/customerList",
    name: "customerList",
    meta: {
      title: "客户列表",
      authId: "90201",
      parentId: "902",
      cache: false
    },
    auth: [
      {
        authId: "9020101",
        parentId: "90201",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      }
    ],
    component: _import("customer/customerList")
  },
  90202: {
    path: "/recordList",
    name: "recordList",
    meta: {
      title: "预录信息",
      authId: "90202",
      parentId: "902",
      cache: false
    },
    auth: [
      {
        authId: "9020201",
        parentId: "90202",
        label: "预录客户",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "901",
            name: "预录客户",
            parentId: "90202"
          }
        ]
      },
      {
        authId: "9020202",
        parentId: "90202",
        label: "一键导入",
        category: "Button",
        type: "primary",
        handle: "handleImport"
      },
      {
        authId: "9020203",
        parentId: "90202",
        label: "编辑",
        handle: "handleEdit",
        addRoutePath: [
          {
            authId: "901",
            name: "预录客户",
            parentId: "90202"
          }
        ]
      }
    ],
    component: _import("customer/recordList")
  },

  90203: {
    path: "/invitation",
    name: "invitation",
    meta: {
      title: "邀约管理",
      authId: "90203",
      parentId: "902",
      cache: false
    },
    auth: [
      {
        authId: "9020301",
        parentId: "90203",
        label: "再次电联",
        handle: "handleMoreCall"
        // ruleObj: {
        //   attr: 'status',
        //   rule: {
        //     0: '上架',
        //     1: '下架'
        //   }
        // }
      },
      {
        authId: "9020302",
        parentId: "90203",
        label: "取消预约",
        handle: "handleCancel"
      },
      {
        authId: "9020303",
        parentId: "90203",
        label: "更新备注",
        handle: "handleUpdateRemark"
      },
      {
        authId: "9020304",
        parentId: "90203",
        label: "修改时间",
        handle: "handleChangeTime"
      },
      {
        authId: "9020305",
        parentId: "90203",
        label: "电联一下",
        handle: "handleCall"
      },
      {
        authId: "9020306",
        parentId: "90203",
        label: "预约时间",
        handle: "handleAppoint"
      },
      {
        authId: "9020307",
        parentId: "90203",
        label: "更新备注",
        handle: "handleUpdateRemark"
      }
    ],
    component: _import("customer/invitation")
  },
  901: {
    path: "/editCustomer",
    name: "editCustomer",
    meta: {
      title: "预录客户",
      authId: "901",
      parentId: "90202",
      cache: false,
      sideHidden: false,
      activePath: "/recordList"
    },
    component: _import("customer/editCustomer")
  }
}

// { routerName }
